import React, { Component} from 'react'
import { NavLink,useNavigate } from "react-router-dom";

export default class Header extends Component {
    render () {
        return (
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
    {/* Left navbar links */}
    <ul className="navbar-nav">
      <li className="nav-item">
        <a className="nav-link" data-widget="pushmenu" href="#"><i className="fas fa-bars" /></a>
      </li>
      {/* <li className="nav-item d-none d-sm-inline-block">
      <NavLink to="/" className="nav-link">
                  <p>Home</p>
                </NavLink>
      </li> */}
      {/* <li className="nav-item d-none d-sm-inline-block">
        <a href="#" className="nav-link">Contact</a>
      </li> */}
    </ul>
    {/* SEARCH FORM */}
    
    {/* Right navbar links */}
    <ul className="navbar-nav ml-auto">
      {/* Messages Dropdown Menu */}
      <li className="nav-item dropdown">
        
      </li>
      {/* Notifications Dropdown Menu */}
      
      
    </ul>
  </nav>
        )
    }
}